import { AppThunk } from "store";
import { PaginationList } from "types/game";

export const currentIndexLogic =
  (
    isSubject: boolean,
    listExercise: PaginationList[],
    data: any,
    isMix?: boolean,
    type?: any
  ): AppThunk =>
  (dispatch, getState) => {
    if (type === "hand_play" && getState().game.gameInfoHandPlay.isComponent) {
      return getState().game.gameInfoHandPlay.currentIndex;
    }
    if (!listExercise) return;
    if (type === "mini_bridge") {
      const miniBridgeGameId = getState().game.gameInfoMiniBridge?.gameId;
      const findIndex = listExercise.findIndex((val) => val?.Data?.ExIndex === miniBridgeGameId);
      if (findIndex !== -1) {
        return findIndex + 1;
      }
      return 1;
    }
    if (isSubject) {
      const resLevels = localStorage.getItem("levels");
      const audit: number[] = [];
      let exerciseFilter: PaginationList[] = [];
      if (resLevels) {
        const val = JSON.parse(resLevels);
        if (val?.ease) {
          audit.push(10);
        }
        if (val?.medium) {
          audit.push(20);
        }
        if (val?.hard) {
          audit.push(30);
        }
        if (audit.length > 0) {
          const exerciseBoofer: any[] = [];
          listExercise?.forEach((item) => {
            const findAudit = audit.find(
              (item_audit) => item_audit === item?.Data?.Level || item_audit === item?.Data?.ExLevel
            );
            if (findAudit) {
              exerciseBoofer.push(item);
            }
          });
          const booferArr: any[] = [];
          exerciseBoofer.forEach((item) => {
            let repeated = 0;
            booferArr.forEach((val) => {
              if (
                item?.Data?.Id_PHExercise === val?.Data?.Id_PHExercise &&
                item?.Data?.CategoryId === val?.Data?.CategoryId
              ) {
                repeated += 1;
              }
            });
            if (repeated !== 1) {
              booferArr.push(item);
            }
          });
          exerciseFilter = [...booferArr];
        } else {
          if (listExercise) {
            exerciseFilter = [...listExercise];
          }
        }
      } else {
        if (listExercise) {
          exerciseFilter = [...listExercise];
        }
      }
      const findIndex = listExercise?.findIndex(
        (val: any) =>
          (val?.Data?.Id_PHExercise === data?.Id_PHExercise &&
            val?.Data?.CategoryId === data?.CategoryId) ||
          (val?.Data?.ExIndex_Subject === data?.ExIndex_Subject && !!data?.ExIndex_Subject)
      );
      return findIndex + 1;
    } else if (isMix) {
      const resLevels = localStorage.getItem("levels");
      const audit: number[] = [];
      let exerciseFilter: PaginationList[] = [];
      if (resLevels) {
        const val = JSON.parse(resLevels);
        if (val?.ease) {
          audit.push(10);
        }
        if (val?.medium) {
          audit.push(20);
        }
        if (val?.hard) {
          audit.push(30);
        }
        if (audit.length > 0) {
          const exerciseBoofer: any[] = [];
          listExercise?.forEach((item) => {
            const findAudit = audit.find(
              (item_audit) =>
                Number(item_audit) === Number(item?.Data?.Level) ||
                item_audit === item?.Data?.ExLevel
            );
            if (findAudit) {
              exerciseBoofer.push(item);
            }
          });
          exerciseFilter = [...exerciseBoofer];
        } else {
          if (listExercise) {
            exerciseFilter = [...listExercise];
          }
        }
      } else {
        if (listExercise) {
          exerciseFilter = [...listExercise];
        }
      }
      const findIndex = exerciseFilter?.findIndex(
        (val: any) =>
          (val?.Data?.Id === data?.Id_Bid || val?.Data?.Id === data?.Id_Exercise) &&
          val?.Data?.CourseId === data?.CourseId
      );

      return findIndex + 1 || 1;
    }
    const findData: any = listExercise.find((val) => {
      if (
        type !== "bidding" &&
        type !== "def_lead" &&
        val?.Data?.ExIndex &&
        val?.Data?.ExIndex === data?.ExIndex &&
        val?.Data?.CategoryId === data?.CategoryId
      ) {
        return true;
      } else if (type === "def_lead" && val?.Data?.Name === data?.DefenseLeadName) {
        return true;
      } else if (
        type === "bidding" &&
        val?.Data?.Name &&
        val?.Data?.Name === data?.ExerciseName &&
        val?.Data?.CourseId === data?.CourseId
      ) {
        return true;
      } else if (
        type === "bidding_interactive" &&
        val?.Data?.Name === data?.BidName &&
        val?.Data?.CourseId === data?.CourseId
      ) {
        return true;
      }
    });

    return (
      findData?.Data?.index ||
      data?.index ||
      data?.ExIndex ||
      data?.ExIndex_Subject ||
      data?.ExerciseName ||
      data?.DefenseLeadName ||
      data?.BidName ||
      ""
    );
  };

export const currentIndexLogicRedux =
  (
    isSubject: boolean,
    listExercise: PaginationList[],
    data: any,
    isMix?: boolean,
    type?: any
  ): AppThunk =>
  (dispatch, getState) => {
    if (!listExercise) return;
    if (isSubject) {
      const resLevels = localStorage.getItem("levels");
      const audit: number[] = [];
      let exerciseFilter: PaginationList[] = [];
      if (resLevels) {
        const val = JSON.parse(resLevels);
        if (val?.ease) {
          audit.push(10);
        }
        if (val?.medium) {
          audit.push(20);
        }
        if (val?.hard) {
          audit.push(30);
        }
        if (audit.length > 0) {
          const exerciseBoofer: any[] = [];
          listExercise?.forEach((item) => {
            const findAudit = audit.find(
              (item_audit) => item_audit === item?.Data?.Level || item_audit === item?.Data?.ExLevel
            );
            if (findAudit) {
              exerciseBoofer.push(item);
            }
          });
          const booferArr: any[] = [];
          exerciseBoofer.forEach((item) => {
            let repeated = 0;
            booferArr.forEach((val) => {
              if (
                item?.Data?.Id_PHExercise === val?.Data?.Id_PHExercise &&
                item?.Data?.CategoryId === val?.Data?.CategoryId
              ) {
                repeated += 1;
              }
            });
            if (repeated !== 1) {
              booferArr.push(item);
            }
          });
          exerciseFilter = [...booferArr];
        } else {
          if (listExercise) {
            exerciseFilter = [...listExercise];
          }
        }
      } else {
        if (listExercise) {
          exerciseFilter = [...listExercise];
        }
      }
      const findIndex = listExercise?.findIndex(
        (val: any) =>
          (val?.Data?.Id_PHExercise === data?.Id_PHExercise &&
            val?.Data?.CategoryId === data?.CategoryId) ||
          (val?.Data?.ExIndex_Subject === data?.ExIndex_Subject && !!data?.ExIndex_Subject)
      );
      return findIndex + 1;
    } else if (isMix) {
      const resLevels = localStorage.getItem("levels");
      const audit: number[] = [];
      let exerciseFilter: PaginationList[] = [];
      if (resLevels) {
        const val = JSON.parse(resLevels);
        if (val?.ease) {
          audit.push(10);
        }
        if (val?.medium) {
          audit.push(20);
        }
        if (val?.hard) {
          audit.push(30);
        }
        if (audit.length > 0) {
          const exerciseBoofer: any[] = [];
          listExercise?.forEach((item) => {
            const findAudit = audit.find(
              (item_audit) =>
                Number(item_audit) === Number(item?.Data?.Level) ||
                item_audit === item?.Data?.ExLevel
            );
            if (findAudit) {
              exerciseBoofer.push(item);
            }
          });
          exerciseFilter = [...exerciseBoofer];
        } else {
          if (listExercise) {
            exerciseFilter = [...listExercise];
          }
        }
      } else {
        if (listExercise) {
          exerciseFilter = [...listExercise];
        }
      }
      const findIndex = exerciseFilter?.findIndex(
        (val: any) =>
          (val?.Data?.Id === data?.Id_Bid || val?.Data?.Id === data?.Id_Exercise) &&
          val?.Data?.CourseId === data?.CourseId
      );

      return findIndex + 1 || 1;
    }

    const findData: any = listExercise.find((val) => {
      if (
        type !== "bidding" &&
        type !== "def_lead" &&
        val?.Data?.ExIndex &&
        val?.Data?.ExIndex === data?.ExIndex &&
        val?.Data?.CategoryId === data?.CategoryId
      ) {
        return true;
      } else if (type === "def_lead" && val?.Data?.Name === data?.DefenseLeadName) {
        return true;
      } else if (
        type === "bidding" &&
        val?.Data?.Name &&
        val?.Data?.Name === data?.ExerciseName &&
        val?.Data?.CourseId === data?.CourseId
      ) {
        return true;
      } else if (
        type === "bidding_interactive" &&
        val?.Data?.Name === data?.BidName &&
        val?.Data?.CourseId === data?.CourseId
      ) {
        return true;
      }
    });

    return (
      findData?.Data?.index ||
      data?.index ||
      data?.ExIndex ||
      data?.ExIndex_Subject ||
      data?.ExerciseName ||
      data?.DefenseLeadName ||
      data?.BidName ||
      ""
    );
  };

export const itemNumber = (isSubject: boolean, data?: any) => {
  if (isSubject) {
    return data?.Id_PHExercise;
  }

  return (
    data?.index ||
    data?.ExIndex ||
    data?.ExIndex_Subject ||
    data?.ExerciseName ||
    data?.DefenseLeadName ||
    data?.BidName ||
    data?.Index ||
    ""
  );
};

export const currentIndexLogicPositionSubject = (listExercise: PaginationList[], data: any) => {
  const findIndex = listExercise?.findIndex(
    (val: any) =>
      (val?.Data?.Id_PHExercise === data?.Id_PHExercise &&
        val?.Data?.CategoryId === data?.CategoryId) ||
      (val?.Data?.ExIndex_Subject === data?.ExIndex_Subject && !!data?.ExIndex_Subject) ||
      (val?.Data?.ExIndex === data?.ExIndex &&
        val?.Data?.CategoryId === data?.CategoryId &&
        !data?.Id_PHExercise &&
        !!data?.ExIndex)
  );

  if (findIndex !== -1) {
    return findIndex;
  }
  return Number(data?.ExIndex || data?.Id_PHExercise || data?.ExIndex_Subject);
};
